export { default } from './StaticPage';
